import { override } from 'flarum/common/extend';
// flarum-tags' TagListState only remembers an include once its request has
// come back, so two load(['parent']) made while the first is still in
// flight each send their own GET /api/tags - on the home page, the forums
// menu (addForumsMenu) and the index filters (DiscussionFilters) both do,
// on every first page load: the same ~25 KB fetched twice. Callers asking
// for the same includes at the same time now share one request.
export default function shareTagListRequests() {
  const inFlight = new Map();
  override('ext:flarum/tags/common/states/TagListState', 'query', function (original, includes) {
    const query = original;
    const wanted = includes ?? [];
    const key = [...wanted].sort().join(',');
    let request = inFlight.get(key);
    if (!request) {
      request = query(wanted).finally(() => inFlight.delete(key));
      inFlight.set(key, request);
    }
    return request;
  });
}